// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XKzx9UOsOhQ_cIlQtJg4{box-shadow:inset 0 0 0 1px var(--border-neutral-default);border-radius:6px;flex-direction:column;gap:24px;display:flex}.XKzx9UOsOhQ_cIlQtJg4.H7NOak9TVCcHWegFRFxU{padding:4px}.XKzx9UOsOhQ_cIlQtJg4.H7NOak9TVCcHWegFRFxU .nrWE3AZLyMMiRnZyXFeb{gap:12px;padding:8px}.XKzx9UOsOhQ_cIlQtJg4.etgQmm_SKAJgNaZIen54{padding:24px}.XKzx9UOsOhQ_cIlQtJg4.etgQmm_SKAJgNaZIen54 .bQIW3ayDNU4hGHmNHUHR{min-height:24px}.IQYIlHA1ErkApEmNy3tA{flex-direction:column;gap:4px;display:flex}.bQIW3ayDNU4hGHmNHUHR{align-items:center;display:flex}.UdvnYQGR3Ut1wM6DvfRz{flex:1 0 0;align-items:center;gap:4px;display:flex}.nrWE3AZLyMMiRnZyXFeb{flex-direction:row;justify-content:space-between;align-items:flex-start;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `XKzx9UOsOhQ_cIlQtJg4`,
	"sizesmall": `H7NOak9TVCcHWegFRFxU`,
	"content": `nrWE3AZLyMMiRnZyXFeb`,
	"sizemedium": `etgQmm_SKAJgNaZIen54`,
	"rightContent": `bQIW3ayDNU4hGHmNHUHR`,
	"left": `IQYIlHA1ErkApEmNy3tA`,
	"row": `UdvnYQGR3Ut1wM6DvfRz`
};
export default ___CSS_LOADER_EXPORT___;
